import React, { useEffect, useState } from "react";
import BlockHeader from "../../component/BlockHeader/BlockHeader";
import { useSearchParams } from "react-router-dom";
import { popinfo } from "../../component/Fancybox/Fancybox";
import Interests from "../../component/Interests/Interests";
import _ from "lodash";
import api from "../../api";
import "./PageRegistrationInterest.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default () => {
    let [searchParams]  = useSearchParams();
    let location        = useLocation();
    let navigation      = useNavigate();

    const[userInterests, setUserInterests]          = useState(false);
    const[interests, setInterests]                  = useState(false);

    const saveInterest = () => {

        var SavingLoader = popinfo('loader', 'Saving Interest', 'Please Wait');

        api('/Account/Step-2', 'post', {
            u : searchParams.get('u')
            ,t : searchParams.get('t')
            ,service : searchParams.get('service')
            ,interest : _.map(_.filter(interests, function(interest){
                return interest.isSelected;
            }),_.property('InterestID')) 
        })
            .then(function(response){
                SavingLoader.close();

                let sourceRegItem = window.localStorage.getItem('crowdbees-reg-deep-link');

                if(sourceRegItem)
                {
                    window.localStorage.setItem('crowdbees-reg-deep-link', '');
                    
                    window.location.href = sourceRegItem;
                }
                else
                {
                    navigation('/registration/get-started' + location.search);
                }


            })
            .catch((error) => {
                popinfo('error', 'Saving Interest', error, {}, SavingLoader);
            });
    }

    useEffect(() => {
        api('/Account/Step-2', 'get', {
            u : searchParams.get('u')
            ,t : searchParams.get('t')
            ,service : searchParams.get('service')
        })
        .then((response) => {
            setUserInterests(response.interest);
        })
    },[]);

    return (
        <div className="container w-800">
            <span className=" text-sm block mb-md">Step 2 of 3</span>
            <BlockHeader title="Select Your Interest" desc="Choose a variety of interests that represent you, find a suitable initiative or be found by an initiator who is looking for in your field" />

            {
                userInterests === false 
                ? <span className="skeleton"></span> 
                : <Interests selectedInterests={userInterests} selectInterest={(Sentinterests) => {
                    setInterests(Sentinterests);
                }} />
            }

            <div className="flex-flat mt-md">
                <div>
                    
                    <Link to={'/registration' + location.search}>
                        <button className="btn ">Prev</button>
                    </Link>
                </div>
                {
                    interests !== false && 
                    <div className="text-right">
                        <button className="btn btn-orange" onClick={saveInterest}>Next</button>
                    </div>
                }
            </div>
        </div>
    )
}